import styled from "styled-components";
import {CssRule} from "../../../../../../themes/architecture/css-helpers/css-rule";

export const SearchInputMobileDefaultBox = styled.ul`
      position: relative;
      margin: 1rem 0 0 0;

      ${CssRule.For.miniOrbit.build()} & {
            margin-left: 2rem;
            margin-right: 1rem;
      }
`;